import { FC, useState } from "react";

import { Grid, Icon, Image, Paragraph } from "capitalrx-components-2.0";

import RequestModal from "@/components/GetCardModals/RequestModal";
import { RequestTypes } from "@/types/AdvantageCardRequest";
import styles from "./GetAdvantageCardCTA.module.scss";

import TextImage from "@/static/images/image-phone-hand-min.png";
import EmailImage from "@/static/images/image-computer-min.png";
import PrintImage from "@/static/images/image-print-min.png";

const GetAdvantageCard: FC = (): JSX.Element => {
  const [showModalState, setShowModalState] = useState(false);
  const [modalType, setModalType] = useState<RequestTypes>(RequestTypes.null);

  const showModal = (type: RequestTypes): void => {
    setModalType(type);
    setShowModalState(true);
  };

  const closeModal = (): void => {
    setShowModalState(false);
    return null;
  };

  return (
    <div className={styles.AdvantageCTA} data-testid="advantage-get-card-cta">
      <Paragraph className="sectionTitle">
        Are you tired of overpaying for your medications?
        <span className="DisplayBlock">
          Download your <span className={styles.AdvantageCTABlue}>FREE</span> savings card to unlock discounts*
        </span>
      </Paragraph>

      <Grid container justifyContent="center" className={styles.AdvantageCTAButtonWrapper}>
        <Grid item colLg={4} colMd={3} colSm={6}>
          <button
            data-testid="text-button"
            className={`${styles.AdvantageCTAButton} ${styles.purple}`}
            onClick={() => showModal(RequestTypes.text)}
          >
            <div className={styles.AdvantageCTAButtonImage}>
              <Image src={TextImage} alt="Request Card by Text" ariaHidden="true" />
            </div>
            <div className={styles.AdvantageCTAButtonText}>
              Text card
              <span>
                {" "}
                <Icon name="message-dots" color="white" className="caprx-icon-messages-bubble" ariaHidden="true" />
              </span>
            </div>
          </button>
        </Grid>
        <Grid item colLg={4} colMd={3} colSm={6}>
          <button
            data-testid="email-button"
            className={`${styles.AdvantageCTAButton} ${styles.blue}`}
            onClick={() => showModal(RequestTypes.email)}
          >
            <div className={styles.AdvantageCTAButtonImage}>
              <Image src={EmailImage} alt="Request Card by Email" ariaHidden="true" />
            </div>
            <div className={styles.AdvantageCTAButtonText}>
              Email card
              <span>
                {" "}
                <Icon name="envelope-closed" color="white" className="caprx-icon-mail-letter" ariaHidden="true" />
              </span>
            </div>
          </button>
        </Grid>
        <Grid item colLg={4} colMd={3} colSm={6}>
          <button
            data-testid="print-button"
            className={`${styles.AdvantageCTAButton} ${styles.green}`}
            onClick={() => showModal(RequestTypes.print)}
          >
            <div className={styles.AdvantageCTAButtonImage}>
              <Image src={PrintImage} alt="Print Card" ariaHidden="true" />
            </div>
            <div className={styles.AdvantageCTAButtonText}>
              Print card
              <span>
                {" "}
                <Icon name="printer" color="white" className="caprx-icon-print" ariaHidden="true" />
              </span>
            </div>
          </button>
        </Grid>
      </Grid>

      <Paragraph className={`${styles.AdvantageCTADisclaimer} roboto`} testId="get-advantage-bulletpoints">
        No membership fees <span>&bull;</span> No credit card required <span>&bull;</span> No expiration <span>&bull;</span> One card for
        the whole family
      </Paragraph>

      <Paragraph className={styles.AdvantageCTANote} testId="get-advantage-disclaimer">
        *This savings program is not health insurance and cannot be used in conjunction with insurance.
        The range of discounts for prescription services provided under the card will vary depending on the type of pharmacy and medication
        received. Plan member is obligated to pay for all prescriptions, but will receive a discount from those pharmacies that have
        contracted with the discount card.
      </Paragraph>

      <RequestModal type={modalType} visible={showModalState} onClose={closeModal} />
    </div>
  );
};

export default GetAdvantageCard;
